import request from "./request";

export const getGlobalSettings = () =>
  request({
    url: "/settings",
    method: "get",
  });
export const getCommonData = () =>
  request({
    url: "/common",
    method: "get",
  });
